import { render, staticRenderFns } from "./trainingApplication.vue?vue&type=template&id=cbf456d6&scoped=true&"
import script from "./trainingApplication.vue?vue&type=script&lang=js&"
export * from "./trainingApplication.vue?vue&type=script&lang=js&"
import style0 from "./trainingApplication.vue?vue&type=style&index=0&id=cbf456d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf456d6",
  null
  
)

export default component.exports